/**
 * Contact map for .osm-map boxes (inc/map.php).
 *
 * A Leaflet map in the site's colours: free OpenStreetMap tiles, tinted cream and red by an
 * SVG duotone filter, and one place label ("Barwani") with a rippling dot instead of a pin.
 * Leaflet (assets/vendor/leaflet) loads only when the box comes near the screen, so the rest of the
 * page never waits for it. Nothing runs when a page has no .osm-map.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var p = window.ssfMap || {};
	var loading = null;

	function esc( s ) {
		var d = document.createElement( 'div' );
		d.textContent = s;
		return d.innerHTML;
	}

	// Leaflet's CSS and script, added once for every map on the page.
	function loadLeaflet() {
		if ( window.L ) {
			return Promise.resolve();
		}
		if ( loading ) {
			return loading;
		}
		loading = new Promise( function ( resolve, reject ) {
			var css = document.createElement( 'link' );
			css.rel = 'stylesheet';
			css.href = p.css;
			document.head.appendChild( css );
			var js = document.createElement( 'script' );
			js.src = p.js;
			js.onload = resolve;
			js.onerror = reject;
			document.head.appendChild( js );
		} );
		return loading;
	}

	// The duotone: tile brightness is mapped from Brand Red (dark) through Sand to Cream (light).
	function addFilter() {
		if ( document.getElementById( 'ssf-map-tone' ) ) {
			return;
		}
		var ns = 'http://www.w3.org/2000/svg';
		var svg = document.createElementNS( ns, 'svg' );
		svg.setAttribute( 'aria-hidden', 'true' );
		svg.setAttribute( 'width', '0' );
		svg.setAttribute( 'height', '0' );
		svg.style.position = 'absolute';
		svg.innerHTML =
			'<filter id="ssf-map-tone" color-interpolation-filters="sRGB">' +
			'<feColorMatrix type="matrix" values=".2126 .7152 .0722 0 0 .2126 .7152 .0722 0 0 .2126 .7152 .0722 0 0 0 0 0 1 0"/>' +
			'<feComponentTransfer>' +
			'<feFuncR type="table" tableValues="' + p.tone.r + '"/>' +
			'<feFuncG type="table" tableValues="' + p.tone.g + '"/>' +
			'<feFuncB type="table" tableValues="' + p.tone.b + '"/>' +
			'</feComponentTransfer></filter>';
		document.body.appendChild( svg );
	}

	function build( box ) {
		var lat = parseFloat( p.lat );
		var lng = parseFloat( p.lng );
		var L = window.L;
		var touch = L.Browser.mobile;

		var map = L.map( box, {
			center: [ lat, lng ],
			zoom: parseInt( p.zoom, 10 ) || 13,
			scrollWheelZoom: false,
			dragging: ! touch,
			tap: false,
			zoomSnap: 1,
		} );
		map.attributionControl.setPrefix( false );

		L.tileLayer( 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			minZoom: 9,
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
		} ).addTo( map );

		L.marker( [ lat, lng ], {
			keyboard: false,
			interactive: false,
			icon: L.divIcon( {
				className: 'osm-place',
				iconSize: [ 14, 14 ],
				iconAnchor: [ 7, 7 ],
				html: '<span class="osm-dot" aria-hidden="true"></span><span class="osm-name">' + esc( p.name || '' ) + '</span>',
			} ),
		} ).addTo( map );

		box.classList.add( 'is-live' );
		box.setAttribute( 'aria-label', 'Map of ' + ( p.label || p.name || 'our location' ) );
	}

	function setup( box ) {
		if ( isNaN( parseFloat( p.lat ) ) || isNaN( parseFloat( p.lng ) ) || ! p.js ) {
			return;
		}
		addFilter();
		var start = function () {
			loadLeaflet().then( function () {
				build( box );
			} ).catch( function () {} );
		};
		if ( ! ( 'IntersectionObserver' in window ) ) {
			start();
			return;
		}
		var io = new IntersectionObserver( function ( entries ) {
			if ( entries[ 0 ].isIntersecting ) {
				io.disconnect();
				start();
			}
		}, { rootMargin: '400px 0px' } );
		io.observe( box );
	}

	function init() {
		if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
			return;
		}
		Array.prototype.forEach.call( document.querySelectorAll( '.osm-map' ), setup );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
